var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.488,
    height: 18.693,
    viewBox: "0 0 30.488 18.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video-camera",
    d: "M30.8,7.7a1.474,1.474,0,0,0-1.474,0l-5.2,2.565A4.423,4.423,0,0,0,19.693,6H6.423A4.423,4.423,0,0,0,2,10.423V19.27a4.423,4.423,0,0,0,4.423,4.423h13.27a4.423,4.423,0,0,0,4.423-4.261l5.249,2.624a1.461,1.461,0,0,0,2.123-1.312V8.949A1.474,1.474,0,0,0,30.8,7.7ZM21.167,19.27a1.474,1.474,0,0,1-1.474,1.474H6.423A1.474,1.474,0,0,1,4.949,19.27V10.423A1.474,1.474,0,0,1,6.423,8.949h13.27a1.474,1.474,0,0,1,1.474,1.474Zm7.372-.914-4.423-2.212V13.549l4.423-2.212Z",
    transform: "translate(-1.5 -5.5)",
    fill: "#fe6831",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.0543300216633ba2e9d5dbfc88975613.svg";
export { ForwardRef as ReactComponent };